import { __makeTemplateObject } from "tslib";
import React, { useContext } from 'react';
import { css } from 'styled-components';
import get from 'lodash/get';
import { createComponent } from '../utils';
import { Context as FormbotContext } from './Formbot';
export var StyledFormError = createComponent({
    name: 'FormError',
    tag: 'span',
    style: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: block;\n    margin: 4px 0 0 1px;\n    color: ", ";\n    font-size: 14px;\n    font-weight: 500;\n  "], ["\n    display: block;\n    margin: 4px 0 0 1px;\n    color: ", ";\n    font-size: 14px;\n    font-weight: 500;\n  "])), function (p) { return p.theme.colors.red; }),
});
export var FormError = function (_a) {
    var _b = _a.name, name = _b === void 0 ? '' : _b, children = _a.children;
    var context = useContext(FormbotContext);
    var hasNameOnly = !!name && typeof children !== 'function';
    var hasRenderProp = !!name && typeof children === 'function';
    var error = get(context, ['errors', name]);
    if (hasNameOnly && error) {
        return React.createElement(StyledFormError, null, error);
    }
    return hasRenderProp ? (error ? (React.createElement(StyledFormError, null, children(error, context))) : null) : (React.createElement(StyledFormError, null, children));
};
var templateObject_1;
//# sourceMappingURL=FormError.js.map